import { ThemeProvider } from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import { ThemeProvider as ThemeProviderNative } from "@rentiohq/shared-frontend/dist/components/theme/styled-components.native";
import rentioTheme, {
  rentioThemeNative,
} from "@rentiohq/shared-frontend/dist/components/theme/theme.rentio";
import logger from "@rentiohq/shared-frontend/dist/logger";
import consoleLogger from "@rentiohq/shared-frontend/dist/logger/loggers/logger.console";
import { ToastContainer } from "@rentiohq/shared-frontend/dist/managers/Toast";
import { setLocale } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { setStore } from "@rentiohq/shared-frontend/dist/utils/redux/redux.utils";
import { AppRouter } from "AppRouter";
import { I18nProvider } from "providers/I18nProvider";
import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "redux/store";

if (process.env.NODE_ENV === "development") {
  logger.registerLogger(consoleLogger);
}

setLocale(navigator.language);
setStore(store);

export class App extends React.Component {
  // Render
  public render() {
    return (
      <ReduxProvider store={store}>
        <ThemeProvider theme={rentioTheme}>
          <ThemeProviderNative theme={rentioThemeNative}>
            <ToastContainer />
            <I18nProvider>
              <AppRouter />
            </I18nProvider>
          </ThemeProviderNative>
        </ThemeProvider>
      </ReduxProvider>
    );
  }
}
